import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
  } from "react";
  import { PencilIcon, TrashIcon } from "@heroicons/react/outline";
  import CustomTable, { CustomColumn } from "../../components/CustomTable";
  import styles from "./index.module.scss";
  import {
    Button,
    Card,
    Col,
    Form,
    Row,
    Stack,
    Toast,
    ToastContainer,
  } from "react-bootstrap";
  import CustomField from "../AdminForms/CustomField";
  import CustomModal from "../AdminForms/CustomModal";
  import { AppContext } from "../../common/AppProvider";
import { createSummerSessionData, getSummerSessionData, updateSummerSessionData } from "../../services/summerSessionsDataTable";
import moment from "moment";

  export const SummerSessionData = () => {
    const { data } = useContext(AppContext);
  
    const columns: Array<CustomColumn> = [
      {
        name: "TERM_CD",
        label: "Term Code",
        cellClass: `${styles.uid1_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 40,
      },
      {
        name: "SES_CD",
        label: "Session Code",
        cellClass: `${styles.updateddate_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 40,
      },
      {
        name: "SES_GRP_CD",
        label: "Group Code",
        cellClass: `${styles.academicyear_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 120,
      },
      {
        name: "TERM_SES_STRT_DT",
        label: "Session Start Date",
        cellClass: `${styles.academicyear_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 120,
      },      
      {
        name: "TERM_SES_LAST_DT",
        label: "Session End Date",
        cellClass: `${styles.academicyear_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 120,
      },      
      {
        name: "updated_at",
        label: "Last Updated",
        cellClass: `${styles.updateddate_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 100,
        sortable: true,
      },
      {
        name: "updated_by",
        label: "Updated by",
        cellClass: `${styles.updateddate_col}`,
        showInExcel: true,
        headerClass: `text-nowrap`,
        width: 100,
      },
      {
        name: "Actions",
        label: "Actions",
        headerClass: `text-center`,
        renderRow: (_, row, idx) => rowActions(row, idx),
        width: 70,
      },
    ];

    const ref = useRef();
    const [currData, setCurrData] = useState<any>({});
    const [currIndex, setCurrIndex] = useState(null);  
    const [summerSessionData, setSummerSessionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true); 
    const [showModal, setShowModal] = useState(null);
    
    async function fetchSummerSessionsTable() {
        setIsLoading(true);
        const data = await getSummerSessionData();
        if (data.resData?.data) {
            setSummerSessionData(data.resData.data);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchSummerSessionsTable();
        const data = [];
    }, []);    
    
    
    const rowActions = useCallback((row, index) => {
        return (
        <Stack className="flex-row justify-content-center" gap={2}>
            <Button
            title="Edit Row"
            size="sm"
            onClick={() => onEditRow(index, row)}
            className="bg-transparent border-0"
            >
            <PencilIcon color="grey" width={18} />
            </Button>
        </Stack>
        );
    }, []);  
    
    const onEditRow = (index, row) => {
        setCurrData((prev) => ({
          ...prev,
          ...row,
          index,
        }));
        setCurrIndex(index);
        setShowModal("Edit");
      };    

      const handleCurrValChange = (e) => {
        setCurrData((prev) => {
          prev[e.target.name] = e.target.value;
          return { ...prev };
        });
      };      

      const handleAddRow = () => {
        setShowModal("Add");
      }; 

      //toDo: add all logic here to make update and add calls.
      const onModalClose = () => {
        setCurrIndex(null);
        setShowModal(null);
        setCurrData({})
      };
      
    const onModalSave = useCallback(async () => {
      try {
        console.log(currData);
        if (showModal === "Edit") {
          if (currIndex === null) {
            throw new Error("Missing edited row index!");
          }
          const payload: any = {
            ...currData,
            updated_by: data?.login["custom:displayName"],
            updated_at: moment().toISOString(),
          };
          console.log(payload);
          delete payload.modified;
          delete payload.isNewRow;
      
            await updateSummerSessionData(payload);
            setSummerSessionData((prev) => {
              prev[currIndex] = { ...currData, modified: true } as any;
              return [...prev];
            });
            await fetchSummerSessionsTable();
        } else {
          setShowModal(null);
          const payload: any = {
            ...currData,
            created_at: moment().toISOString(),
            updated_at: moment().toISOString(),
          };
          console.log(payload);
          delete payload.modified;
          delete payload.isNewRow;
          const resp = await createSummerSessionData(JSON.stringify(payload));
            setSummerSessionData((prev: any) => {
              return [{ ...currData, isNewRow: true }, ...prev];
            });
        
          await fetchSummerSessionsTable();
        }
        onModalClose();
      } catch (err) {
        console.error(err);
        onModalClose();
      }
    }, [currData, currIndex, showModal]);      
      
    return (
        <div className="summer-session-table relative">
        <Col className="relative">
            <Row>
            <CustomTable
                parentClass={styles.fullTableWidth as any}
                isLoading={isLoading}
                rows={summerSessionData || []}
                columns={columns}
                bordered
                ref={ref}
                rowsPerPage={process.env.REACT_APP_ROWS_PAGE}
                rowClass="test"
                responsive
                hasTableActions
                tableActionProps={{
                onAddRow: handleAddRow
                }}
                striped
                title="Summer Session Table"
                style={{ tableLayout: "fixed" }}
                pagination="default"
            />
            </Row>
        </Col>
        <div
            className="d-flex justify-content-end align-items-center"
            style={{ gap: "10px", flex: 1 }}
        >
            {/* <Button size="sm" onClick={handleAddRow}>
            Add
            </Button> */}
            {/* <Button size="sm" onClick={updateRules}>
            Save
            </Button> */}
        </div>

          <CustomModal
            title={`${showModal} Summer Session Code Table`}
            show={!!showModal}
            onClose={onModalClose}
            onSave={onModalSave}
            primaryBtnText={`${showModal === "Edit" ? "Update" : "Add"}`}
          >
            <Form>
              <Stack className="mb-3" gap={3}>
                <CustomField
                  md={12}
                  onChange={handleCurrValChange}
                  label="Term Code"
                  name="TERM_CD"
                  type="text"
                  value={currData["TERM_CD"]}
                  required
                  disabled={showModal === "Edit"}
                />
                <CustomField
                  md={12}
                  onChange={handleCurrValChange}
                  label="Session Code"
                  name="SES_CD"
                  type="text"
                  value={currData["SES_CD"]}
                  required
                  disabled={showModal === "Edit"}
                />
                <CustomField
                  md={12}
                  onChange={handleCurrValChange}
                  label="Group Code"
                  name="SES_GRP_CD"
                  type="text"
                  value={currData["SES_GRP_CD"]}
                  required
                />
                <CustomField
                  md={12}
                  onChange={handleCurrValChange}
                  label="Session Start Date"
                  name="TERM_SES_STRT_DT"
                  type="Date"
                  value={currData["TERM_SES_STRT_DT"]}
                  required
                  disabled={showModal === "Edit"}
                />
                <CustomField
                  md={12}
                  onChange={handleCurrValChange}
                  label="Session End Date"
                  name="TERM_SES_LAST_DT"
                  type="Date"
                  value={currData["TERM_SES_LAST_DT"]}
                  required
                  disabled={showModal === "Edit"}
                />            
              </Stack>
            </Form>
          </CustomModal>        
        

        </div>
    );

}